import * as $ from 'jquery';
import 'bootstrap';
import 'datepicker';
import 'selectize';
import * as moment from 'moment';
import { bookingFormCommon } from "./c005-bookingform-common";
import { bookingFormSubmit } from "./c005-bookingform-submission";
import { bookingFormRedemption } from "./c005-bookingform-redemption";
import { bookingFormInfant } from "./c005-bookingform-infant";
import { bookingFormSideTrip } from "./c005-bookingform-sidetrip";
import { wcagOptions } from "./wcag";
import { headerContent } from "./c002";
import 'MagnificPopup';

export class mobileBookingFormContent {
	private bookingFormSubmit = new bookingFormSubmit();
	private wcag = new wcagOptions();
	private bcommon = new bookingFormCommon();

	$scopeipad: any = $('#mobile-enrichhotels--container');
	$siteCode: string = '';
	$officeCode: string = '';
	$error: Array<string> = [];

	$instance: any;

	$scopeMob: any = $('#mobile-enrichhotels--container'); // mobile ibe
	// for recent search clicked state to prevent auto focus to the next field with ibe search
	recentSearchActive: boolean = false;
	// value for populating to to location field on from location update complete
	toPrepop: string = null;
	isIbePrepop: boolean = false;
	isUkCitySelectedForIbeSearch: boolean = false;
	/**
	 * @function bookingNav
	 * !!! Global
	 */
	nav(): void {
		let _self = this;
		let $ibeNav: any = $('#bookingNav');
		let bcommon = _self.bcommon;
		let $deviceHeight = $(window).height() / 1.78;

		let $checkInMob: any = $('#mob-checkin--container');
		let $viewBookingMob: any = $('#mob-viewbooking--container');
		let $flightStatusMob: any = $('#mob-flightstatus--container');
		let $loginMob: any = $('#mob-login--container');
		let $loggedinMob: any = $('#mob-logged-in-user-menu');
		let $mhStayMob: any = $('#mob-stay--container');
		let $mhUpgradeMob: any = $('#mob-mhupgrade--container');
		let $mholidayWrapper: any = $('#mobile-mholidays--container');
		let $flightUpgradMob: any = $('#mob-flightupgrade--container');
		let $moreLinksMob: any = $('#mob-more-links--container');

		let $ibeNavList: any = $('#bookingNav li');
		let $mobIbeNav: any = $('#mab-bookingnav.mobile #bookingNav');

		let $errorValidationGen: any = $('.error-validation');
		let $bookingFormTitle: any = $('.booking-form--title');
		let $dateFormTitle: any = $('.date-form--title');
		let $bookdateSelectorGen: any = $('.book-date--selector');
		let $selectizeInputGen: any = $('.ibe-form--container .selectize-control .selectize-input');
		let $couponCodeGen: any = $('.couponCode');
		let $redemptionLogin: any = $('.redemption-login .form-group');

		let $navOverlay: any = $('.mab-nav--overlay');
		let $enrichMobEnrichHotels: any = $('.enrich-revamp .mob-enrich-hotels');
		// let $enrichMobSearchFLight: any = $('.enrich-revamp .link-search-flight');
		let $enrichMobRedeemFLight: any = $('.enrich-revamp .mob-redeem-flights');
		let $bookigflightMob: any = $('#mobile-bookflight--container')
		$enrichMobRedeemFLight.click(function(){
			_self.$scopeMob.hide();
		  });
		// array of both mobile ibe links (top nav & side nav)
		let mobileIbeLinks = [$mobIbeNav.find('.mob-enrich-hotels'), $navOverlay.find('.mob-enrich-hotels'), $enrichMobEnrichHotels];

		// IBE Navigation show/hide Mobile Check in container
		mobileIbeLinks.map(function ($el: any, i: number) {
			$el.click(function () {
				// let $fromLocationMobile: any = $('#fromLocationMobile').parent().find('.selectize-control .selectize-input');
				// let $toLocationMobile: any = $('#toLocationMobile').parent().find('.selectize-control .selectize-input');

				$ibeNavList.removeClass('selected');
				$ibeNavList.find('a.mob-enrich-hotels').parent().addClass('selected');

				_self.$scopeMob.find('.trip-type--container .returnTrip').addClass('selected');
				_self.$scopeMob.show();
				_self.$scopeMob.find('.trip-type--container .returnTrip').trigger('click');
				$bookigflightMob.hide();
				$checkInMob.hide();
				$viewBookingMob.hide();
				$flightStatusMob.hide();
				$mhStayMob.hide();
				$mhUpgradeMob.hide();
				$loginMob.hide();
				$loggedinMob.hide();
				$mholidayWrapper.hide();
				$flightUpgradMob.hide();
				$moreLinksMob.hide();

				// form stuff
				$errorValidationGen.hide();
				$bookingFormTitle.removeClass('has-error');
				$dateFormTitle.removeClass('has-error');
				$bookdateSelectorGen.removeClass('has-error');
				$selectizeInputGen.removeClass('has-error');
				$couponCodeGen.removeClass('has-error');
				$redemptionLogin.removeClass('has-error');
				// $fromLocationMobile.removeClass('has-error');
				// $toLocationMobile.removeClass('has-error');

				bcommon.scrollToTopIBE();
				_self.clearFields();

				if (window.innerWidth > 767 && window.innerWidth < 1200) {

					let $fromLocation: any = _self.$scopeipad.find('.ibe-from--location');
					let $fromSelectize: any = $fromLocation.parent().find('.selectize-control .selectize-input');
					let $toLocation: any = _self.$scopeipad.find('.ibe-to--location');
					let $toSelectize: any = $toLocation.parent().find('.selectize-control .selectize-input');
					let $mcityToSelectInput: any = $('.multi-cityTrip--Container').find('select.mc-to--location');
					let $checkIn: any = $('#check-in--container');
					let $viewBooking: any = $('#view-booking--container');
					let $flightStatus: any = $('#flight-status--container');
					let $login: any = $('#login-container');
					let $mholidays: any = $('#mholiday-ibe--container');
					let $flightHotelBtn: any = $('.flights-hotel-btn');
					let $loggedin: any = $('#logged-in-user-menu');
					let $mhStay: any = $('#ibe-stay--container');
					let $mhUpgrade: any = $('#mhupgrade-in--container');
					$flightHotelBtn.attr('style', 'display:none !important;');
					$ibeNavList.find('a.book-flight').parent().addClass('selected');
					$ibeNav.find('.book-flight').parent().addClass('selected');

					// desktop stuff
					_self.$scopeipad.show();
					$checkIn.hide();
					$viewBooking.hide();
					$flightStatus.hide();
					$login.hide();
					$mholidays.hide();
					$loggedin.addClass('hidden');

					// mobile stuff
					_self.$scopeMob.hide();
					$checkInMob.hide();
					$viewBookingMob.hide();
					$flightStatusMob.hide();
					$loginMob.hide();
					$loggedinMob.hide();
					$mhStay.hide();
					$mhUpgrade.hide();

					// form stuff
					$errorValidationGen.hide();
					$bookingFormTitle.removeClass('has-error');
					$dateFormTitle.removeClass('has-error');
					$bookdateSelectorGen.removeClass('has-error');
					$fromSelectize.removeClass('has-error');
					$toSelectize.removeClass('has-error');
					$mcityToSelectInput.removeClass('has-error');
					$couponCodeGen.removeClass('has-error');
					$redemptionLogin.removeClass('has-error');

				}
				if ($('.enrich-revamp').length > 0) {
					$('.enrich-revamp .enrich-header').addClass('hide');
					$('.enrich-revamp .enrich-mobile-ibe-container').removeClass('hide');
					_self.expandIbe(_self.$scopeMob);
					let targetHeight: any = $(window).innerHeight() + 'px';
					$('.enrich-revamp #mobile-enrichhotels--container').css('height', targetHeight);
					if ($(event.currentTarget).hasClass('mob-redeem-flights')) {
						_self.$scopeMob.find('input[name="cash_miles_type"][value="cash_miles"]').prop('checked', false);
						_self.$scopeMob.find('input[name="cash_miles_type"][value="cash"]').prop('checked', false);
						_self.$scopeMob.find('input[name="cash_miles_type"][value="miles"]').prop('checked', true).trigger('click');
					}
					else {
						_self.$scopeMob.find('input[name="cash_miles_type"][value="miles"]').prop('checked', false);
						_self.$scopeMob.find('input[name="cash_miles_type"][value="cash_miles"]').prop('checked', false);
						_self.$scopeMob.find('input[name="cash_miles_type"][value="cash"]').prop('checked', true);
					}

				}
				_self.$scopeMob.find('.mob-earn-points').parent().addClass('selected');
				if (_self.$scopeMob.find('.mob-earn-points').parent().hasClass('selected')) {
					_self.$scopeMob.find('#mob-enrich-earn-points--container').show();
					_self.$scopeMob.find('#mob-enrich-redeem-points--container').hide();
				}
				$('#mob-enrich-hotels-container .close-bookingroomhotel2').on('click', () => {
					$('[mob-data-booking-passenger-details]').show();
				});
				let $passengerDetails: any = $('[mob-data-booking-passenger-details]');
				let $passengerDetailsActive: any = $('[mob-data-booking-passenger-details-selected]');

				// hide all passenger fields on load
				$passengerDetailsActive.hide();
				$passengerDetails.addClass('passenger-focused');
				$passengerDetails.show();
				$passengerDetails.find('.total-passengers').show();

			});
		});
	}

	/**
	 * @function init
	 * !!! Global
	 */
	init(): void {
		let _self = this;

		let $bookDateSelector: any = _self.$scopeMob.find('.book-date--selector');
		let $bannerEl: any = $('.banner-container');
		let $bannerHeight: number = 0;

		let $alertContainer: any = $('.alert-container');
		let $stickyNavHeight: number;
		let $stickyNavHeightMob: number;

		let $ibeNavList: any = $('#bookingNav li');

		const topNavIbe = $('.mobile#mab-bookingnav [data-mob-enrich--enrich-hotels]');

		let $passengerDetails: any = $('[mob-data-booking-passenger-details]');
		let $passengerDetailsActive: any = $('[mob-data-booking-passenger-details-selected]');

		let $mabHeader: any = $('#mab-header');

		$passengerDetailsActive.hide();
		$passengerDetails.addClass('passenger-focused');
		$passengerDetails.show();
		$passengerDetails.find('.total-passengers').show();
		$bookDateSelector.removeClass('datepicker-selected');

		// double check in case multiple banners are loaded on page
		$bannerEl.each(function (i: number, el: any) {
			$bannerHeight += $(el).height();
		});

		if ($alertContainer.is(':visible')) {
			$stickyNavHeight = $alertContainer.height() + $mabHeader.height();
			$stickyNavHeightMob = $alertContainer.height() + $mabHeader.height() + $bannerHeight;
		} else {
			$stickyNavHeight = $mabHeader;
			$stickyNavHeightMob = $mabHeader.height() + $bannerHeight;
		}

		// if satisfy conditions on page load open bookflight ibe by default
		// no deeplink detected
		// deeplick detected
		let urlParams = _self.bcommon.getUrlVars(window.location.href);

		if ($('body').hasClass('home')) {
			if (urlParams.ibe && urlParams.ibe !== 'bfl') {
				// hide book flight ibe since deep link for other ibes detected
				topNavIbe.hide();
				$ibeNavList.find('a.mob-enrich-hotels').parent().removeClass('selected');
			} else {
				// show book flight ibe
				topNavIbe.show();
				$ibeNavList.find('a.mob-enrich-hotels').parent().addClass('selected');
			}
		} else {
			// hide book flight ibe
			topNavIbe.hide();
			$ibeNavList.find('a.mob-enrich-hotels').parent().removeClass('selected');
		}
		// if ($('.enrich-revamp').length > 0) {
		// 	$('.enrich-revamp .link-swipe-more').on('click', () => {
		// 		$('.enrich-revamp .enrich-header').removeClass('hide');
		// 		$('.enrich-revamp .enrich-sub-home-container').removeClass('hide');
		// 		$('.enrich-revamp .enrich-footer-container').removeClass('hidden-xs');
		// 		$('.enrich-revamp .enrich-home-container').addClass('hide');
		// 		$('.enrich-revamp .enrich-mobile-ibe-container').addClass('hide');
		// 		if (window.innerWidth < 768) {
		// 			$('.enrich-revamp .enrich-subhome-static-head').removeClass('hide');
		// 			$('.enrich-revamp .enrich-header .header-wrapper').addClass('enrich-subhome-header-wrapper');
		// 		}
		// 	});
		// }
		let earnPointsTab = _self.$scopeMob.find('.mob-earn-points');
		let redeemPointsTab = _self.$scopeMob.find('.mob-redeem-points');


		earnPointsTab.click(function () {
			_self.clearFields();
			_self.$scopeMob.find('#mob-enrich-earn-points--container').show();
			_self.$scopeMob.find('#mob-enrich-redeem-points--container').hide();
			_self.$scopeMob.css('padding-bottom', '20px');
			_self.$scopeMob.find('#mob-enrich-point-list li').removeClass('selected');
			_self.$scopeMob.find('.mob-earn-points').parent().addClass('selected');
			_self.$scopeMob.find('.enrich-validation').hide();
			let $errorEls = _self.$scopeMob.find('.has-error');
			$errorEls.each(function () {
				$(this).removeClass('has-error');
			});
		});
		redeemPointsTab.click(function () {
			_self.clearFields();
			_self.$scopeMob.find('#mob-enrich-earn-points--container').hide();
			_self.$scopeMob.find('#mob-enrich-redeem-points--container').show();
			_self.$scopeMob.css('padding-bottom', '20px');
			_self.$scopeMob.find('#mob-enrich-point-list li').removeClass('selected');
			_self.$scopeMob.find('.mob-redeem-points').parent().addClass('selected');
			_self.$scopeMob.find('.enrich-validation').hide();
			let $errorEls = _self.$scopeMob.find('.has-error');
			$errorEls.each(function () {
				$(this).removeClass('has-error');
			});
		});
	}
	clearFields(): void{
		$('.mobEnrichHotelEarnInputtoVal').val('');
		$('#mobile-enrichhotels--container .booking-form--title').removeClass('input-filled');
		$('#mobile-enrichhotels--container .date-form--title').removeClass('input-filled');
		$('.mobEnrichHotelEarnInputtoVal').removeClass('input-focused');
		$('.mobEnrichHotelEarnInputClass').val('');
		$('.mobEnrichHotelEarnInputClass').removeClass('input-focused');
		$('.departureDateMobile').val('');
		$('.departureDateMobile').removeClass('input-focused');
		$('.returnDateMobile').val('');
		$('.returnDateMobile').removeClass('input-focused');
		$('.mobEnrichHotelRedeemInputtoVal').val('');
		$('.mobEnrichHotelRedeemInputtoVal').removeClass('input-focused');
		$('.mobEnrichHotelRedeemInputClass').val('');
		$('.mobEnrichHotelRedeemInputClass').removeClass('input-focused');
		$('.ticket-mob-room--input').val(1);
		$('.ticket-mob-adult--input').val(1);
		$('.ticket-mob-child--input').val(0);
        $('.total-nos-rooms').html('1');
		$('.total-nos').html('1');
	}
	/**
	 * @function setInstance
	 * - set current booking form instance
	 * @param {any} obj - current form object
	 * !!! Properly scoped
	 */
	setInstance(obj: any) {
		let _self = this;
		return _self.$instance = $(obj);
	}

	/**
	 * @function getInstance
	 * retrieve currently assigned booking form instance
	 * @return {any} - current instance
	 */
	getInstance(): any {
		let _self = this;
		console.log(_self.$instance);
		return;
	}



	/**
	 * expand this instance of ibe
	 * extrapolate method so that it can be used elsewhere
	 * instead of just selectize.focus()
	 * @author dominic <dominic.gan@mirumagency.com>
	 */
	expandIbe(instance: any): void {
		let $mobileBookFlightContainer: any = instance;
		let $showMobileCloseBtn: any = $mobileBookFlightContainer.find('.close-container .close-booking');
		let $showMobileToLocation: any = $mobileBookFlightContainer.find('.toLocation');
		let $showMobilePaymentContainer: any = $mobileBookFlightContainer.find('.payment-type-container');
		let $showMobileTripContainer: any = $mobileBookFlightContainer.find('.trip-container');
		let $showMobileSearchContainer: any = $mobileBookFlightContainer.find('.search-container');

		$mobileBookFlightContainer.addClass('expanded');
		$showMobileCloseBtn.addClass('expanded');
		$showMobileSearchContainer.show();
		$showMobileToLocation.show();
		$showMobilePaymentContainer.show();
		$showMobileTripContainer.show();
	}
    mobileDelay(callback:any, ms:any) {
		let timer:any = 0;
		return function() {
		  var context = this, args = arguments;
		  clearTimeout(timer);
		  timer = setTimeout(function () {
			callback.apply(context, args);
		  }, ms || 0);
		};
	  }

	populateTuiMobEnrichEarnLocationList($scope: any): void {
		let _self = this;
		let $hotelInputVal: any;
		$(".mobEnrichHotelEarnInputClass").attr('autocomplete', 'off');
		$scope.find('.mob-enrich-hotel-earn-display-tui-container').on('mouseleave', function () {
			$(this).hide();
			$scope.find('.mobEnrichHotelEarnInputClass').removeClass('hotel-input-boarder');
		});
		$(document).mouseup(function (event: any) {
			if ($(event.target).closest('.mob-enrich-hotel-earn-display-tui-container').length === 0) {
				$scope.find('.mob-enrich-hotel-earn-display-tui-container').hide();
				$scope.find('.mobEnrichHotelEarnInputClass').removeClass('hotel-input-boarder');
				if ($scope.find('#mobEnrichHotelEarnInputVal').val() === '') {
					$scope.find('.mobEnrichHotelEarnInputClass').val('');
					$scope.find('.mobEnrichHotelEarnInputClass').removeClass('input-focused');
					// $('.booking-form--title', $scope.find('.mobEnrichHotelEarnInputClass').parent()).removeClass('input-filled');
				}
			}
		});
		$scope.find('.mobEnrichHotelEarnInputClass').keyup(_self.mobileDelay(function (e:any) {
			let trimSearchVal:any="";
			let searchTimeout:any=null;
			$hotelInputVal = $scope.find('.mobEnrichHotelEarnInputClass').val();
			trimSearchVal=$hotelInputVal.split(" ").join("-");
			if ($hotelInputVal.length > 2) {
		
				$scope.find('.mob-enrich-hotel-earn-display-tui-container').show();
				$scope.find('.mobEnrichHotelEarnInputClass').addClass('hotel-input-boarder');
				let hotellisturl: string = '';
				if (window.location.hostname === 'localhost' && window.location.port == "5000") {
					hotellisturl = '/dummy-data/enrichHotelLocationList.json';
				}
				else {
					hotellisturl = '/bin/services/new/enrichhotellistsearchresult?cityName=' + trimSearchVal;
				}

				$.ajax({
					type: 'GET',
					url: hotellisturl,
					success: function (json: any) {
						if (window.location.hostname !== 'localhost') {
							json = JSON.parse(json);
						}
						_self.mobEarnLocationlList($scope, json);
					},
					error: function (error: any) {
						console.log("Error while getting member info", error);
					}
				});
		

			}
		},500));

	}
	mobEarnLocationlList($scope: any, response: any): any {
		let $hotelList: any = '';
		if (response.code=="200"&& response.results.length) {
			$hotelList += "<div class='hotel-tui-inner'>";
			// Object.keys(response).forEach(function(k){
			var itemCity = response.results;
			if (itemCity.length) {
				$hotelList += "<div class=' hotel-title'><span>Location</span></div>";
				Object.keys(itemCity).forEach(function (n) {

					$hotelList += "<div class='hotel-list' data-hotel" + itemCity[n].id + "= 'HotelID' id=hotel-opt" + n + " data-cityId='" + itemCity[n].id + "'  data-value='" + itemCity[n].name + "|" + itemCity[n].latitude + "," + itemCity[n].longitude + "'>" + itemCity[n]['description'] + "</div>";

				});
			}
			// });
			$hotelList += "</div>";
			$scope.find('.mob-enrich-hotel-earn-display-tui-container').html($hotelList).text();
			$scope.find('.hotel-list').on('click', (evt: any) => {
				var evtVal = $('#' + evt.currentTarget.id).html();
				$scope.find('.mobEnrichHotelEarnInputClass').focus();
				var evtValTextArray = evtVal.split('\u003cem\u003e');
				let getcityID: any = $('#' + evt.currentTarget.id).data('cityid');
				$scope.find('.mobEnrichHotelEarnInputClass').val(evtValTextArray[0]);
				$scope.find('#mobEnrichHotelEarnInputVal').val(evtValTextArray);
				$scope.find('#mobEnrichHotelEarnInputtoVal').val(getcityID);
				// if($scope.selector == "#transferdrop"){
				// 	$scope.find('#geo-coords').val($('#'+evt.currentTarget.id).data('value').split('|')[1]);
				// }
				// if($scope.selector == "#transferpickup")
				// {
				// 	$scope.find('#geo-coords').val($('#'+evt.currentTarget.id).data('value').split('|')[1]);
				// }
				$scope.find('.mob-enrich-hotel-earn-display-tui-container').hide();
				$scope.find('.mobEnrichHotelEarnInputClass').removeClass('hotel-input-boarder');

				let $deptDateContainer = $scope.find('.dep-date');
				let $rtnDateContainer = $scope.find('.rtn-date');
				let $trvInfoContainer = $scope.find('.trv-info');

				$deptDateContainer.show();
				$rtnDateContainer.show();
				$trvInfoContainer.show();
				if ($scope.find('.mobEnrichHotelEarnInputClass').val() !== '') {
					$scope.find('.departureDateMobile').focus();
					$('.departuretransferDate').focus();
					$scope.find('.departureDateMobile').focus();
				}
			});
		} else {
			$hotelList = "<div class='hotel-not'>No result found! </div>";
			$scope.find('.mob-enrich-hotel-earn-display-tui-container').html($hotelList);
		}
	}
	/**
 * @function passengerDetailsEnrichHotelEarn
 * Passenger details container
 * !!! Properly scoped
 */

	/**
	 * @function passengerDetailsHotel
	 * !!! Properly scoped
	 */
	 mobPassengerDetailsEnrichHotelEarn(): void {
		let _self = this;
		let $ticketAdultInput:number   = 1;
		//let $ticketYouthInput:number = 0;
		let $ticketChildInput:number   = 0;
		let $ticketInfantInput:number  = 0;
		let $totalTickets:number       = 1;
		let $totalPassenger:any 	  = _self.$instance.find('#mob-enrich-earn-points--container .total-passengers');
		// adding room count
		let $ticketAdultInput_roomf:number  = 1;
		let $ticketAdultInput_rooms:number  = 1;
		let $ticketAdultInput_roomt:number  = 1;
		let $ticketChildInput_roomf:number  = 0;
		let $ticketChildInput_rooms:number  = 0;
		let $ticketChildInput_roomt:number  = 0;
		// let $ticketInfantInput_roomf:number  = 0;
		// let $ticketInfantInput_rooms:number  = 0;
		// let $ticketInfantInput_roomt:number  = 0;

		let curInstance = _self.$instance.find('#mob-enrich-earn-points--container'); // assign current instance to var as later requests will call latest assigned instance
		let $groupBooking     = curInstance.find('.group-booking');

		$totalPassenger.find('.total-nos').html($totalTickets);
		_self.$instance.find('#mob-enrich-earn-points--container input.total-tickets--value').val($totalTickets);

		$('#mob-enrich-earn-points--container .close-bookingroom_hotelmob2').on('click', () => {
				if ($("#mobroomthre_earnenrichhoteldetails").hasClass('hide'))
				{
					$('#mobroomtwo_earnenrichhoteldetails').addClass('hide');
					$('#mob-enrich-earn-points--container .ticket-mob-adult--input2').val('0');
					$('#mob-enrich-earn-points--containerr .ticket-infant--input2').val('0');
					$('#mob-enrich-earn-points--container.ticket-mob-child--input2').val('0');
					$('#mobroomtwo_earnenrichhoteldetails').find('.booking-ticket--nosr').remove();
					$('#mob-enrich-earn-points--container .close-bookingroom_hotelmob2').addClass('hide');
					updatemobHotelTicketQtys();
				}
				$('#mob-enrich-earn-points--container .add_roomshotel').show();
			});
			$('#mob-enrich-earn-points--container .close-bookingroom_hotelmob3').on('click', () => {
				$('#mobroomthre_earnenrichhoteldetails').addClass('hide');
				$('#mob-enrich-earn-points--container .add_roomshotel').show();
				$('#mob-enrich-earn-points--container .ticket-mob-adult--input3').val('0');
				$('#mob-enrich-earn-points--container .ticket-infant--input3').val('0');
				$('#mob-enrich-earn-points--container .ticket-mob-child--input3').val('0');
				$('#mobroomthre_earnenrichhoteldetails').find('.booking-ticket--nosr').remove();
				$('#mob-enrich-earn-points--container .close-bookingroom_hotelmob2').removeClass('hide');
				updatemobHotelTicketQtys();
			});

			_self.$instance.find('#mob-enrich-earn-points--container .add_roomshotel').on('click', function(e:any) {
				e.preventDefault();
				if ($("#mobroomtwo_earnenrichhoteldetails").hasClass('hide') && $totalTickets < 5)
				{
					$('#mobroomtwo_earnenrichhoteldetails').css({'display': 'block' });
					$('#mobroomtwo_earnenrichhoteldetails').removeClass('hide');
					$('.ticket-mob-adult--input2').val('1');
					$('#mob-enrich-earn-points--container .close-bookingroom_hotelmob2').removeClass('hide');
					curInstance.find('.booking-ticket--nos .age-label').show();
					_self.$instance.find('[mob-data-booking-passenger-details-selected]').show();
					updatemobHotelTicketQtys();
				}
			else if ($("#mobroomthre_redeemenrichhoteldetails").hasClass('hide') && $totalTickets <5) 
				{
					$('#mobroomthre_earnenrichhoteldetails').removeClass('hide');
					$('#mobroomthre_earnenrichhoteldetails').css({'display': 'block' });
					curInstance.find('.booking-ticket--nos .age-label').show();
					$('#mob-enrich-earn-points--container .close-bookingroom_hotelmob2').addClass('hide');
					$('.ticket-mob-adult--input3').val('1');
					$('#mob-enrich-earn-points--container .add_roomshotel').hide();
					updatemobHotelTicketQtys();
				}

			});
		_self.$instance.find('#mob-enrich-earn-points--container .mobile-ticketnos--btn').on('click', function(e:any){
			e.preventDefault();
			let $passengerDetailsActive:any = curInstance.find('[mob-data-booking-passenger-details-selected]');

			// declare passenger input variables
			// scope them to prevent multiple elements from being retrieved
			// (deals component uses the same class name for its inputs)
			let $adultInput  = $passengerDetailsActive.find('.ticket-mob-adult--input');
			let $infantInput = $passengerDetailsActive.find('.ticket-mob-infant--input');
			let $childInput = $passengerDetailsActive.find('.ticket-mob-child--input');
			// let $youthInput  = _self.$passengerDetailsActive.find('.ticket-mob-youth--input');

			let $adultBookingErr  = curInstance.find('.adult-booking--error---mobile');
			let $infantBookingErr = curInstance.find('.infant-booking--error---mobile');


			// get currently acted on input field
			var fieldName   = $(this).attr('data-field'),
			type        = $(this).attr('data-type'),
			input       = curInstance.find("input[name='"+fieldName+"']"),
			currentVal   = parseInt(input.val());

			// apply calculation to acted-on field (plus/minus)
			if (!isNaN(currentVal)) {
					input.data('oldValue', currentVal);
				if (type == 'minus') {
							if (currentVal > parseInt(input.attr('min'))) {
									input.val(currentVal - 1);
									input.trigger('change');
					}
							if (parseInt(input.val()) == parseInt(input.attr('min'))) {
									$(this).attr('disabled', true);
							}
				} else if (type == 'plus') {
					if (currentVal < input.attr('max')) {
									input.val(currentVal + 1);
									input.trigger('change');
					}
					if (parseInt(input.val()) == input.attr('max')) {
						$(this).attr('disabled', true);
					}
				}
			} else {
				input.val(0);
			}
			if (!isNaN(currentVal) && fieldName=="passengersChildren"||fieldName=="passengersChildren2"||fieldName=="passengersChildren3") {
				// show age box if hide
				let room_var=fieldName;
				var currentChild = currentVal+1;
				var currentChildmnus = currentVal-1;
				//flight-container
				$('#mob-enrich-earn-points--container .child-age-grp'+room_var).show();
				// $('.mob-flight-container .child-age-grp').show();
				if (type == 'minus') {
					if(currentChildmnus%8 ==0){
						$( "#mob-enrich-earn-points--container #child-age-col"+room_var+currentChildmnus ).remove();
						// $( ".mob-hotel-container #child-age-col"+currentChildmnus ).remove();

					}else{
						//Append box
						$('#mob-enrich-earn-points--container #child-age-select'+room_var+currentVal).empty();
						// $('.mob-flight-container #child-age-select'+currentVal).empty();
					}
				} else if (type == 'plus') {
					if(currentVal%8 ==0){
						// Append column
						let ageLabel ='';
						let errorChildAge ='';
						if(currentChild == 1){
							ageLabel ='Age';
							errorChildAge ='<div class="child-age-error" data-childage-limit-mob="Child age must be between 2 and 12" data-childage="Child age is missing" style="display: none;">Please enter child age</div>';
						}
						var col1 =currentChild;
						var col2 =currentChild+1;
						var col3 =currentChild+2;
						var col3 =currentChild+2;
						var col4 =currentChild+3;
						var col5 =currentChild+4;
						var col6 =currentChild+5;
						var col7 =currentChild+6;
						var col8 =currentChild+7;
						var col9 =currentChild+9
						let $childAgeList ='<div class="col-lg-12 col-md-12 col-sm-12" id="child-age-col'+room_var+currentVal+'">'
						+'<div class="col-lg-12 col-md-12 col-sm-12 booking-ticket--nosr adult-nos child-age-drp"> <div class="child-age-label">Age of Children</div>'
						+ errorChildAge
						+'	<div class="row" id="child-age-select'+room_var+col1+'">'
						+'	</div>'
						+'	<div class="row" id="child-age-select'+room_var+col2+'"> '
						+'	</div>'
						+'	<div class="row" id="child-age-select'+room_var+col3+'">'
						+'	</div>'
						+'	<div class="row " id="child-age-select'+room_var+col4+'">'
						+'	</div>'
						+'	<div class="row " id="child-age-select'+room_var+col5+'"> '
						+'	</div>'
						+'	<div class="row " id="child-age-select'+room_var+col6+'">'
						+'	</div>'
						+'	<div class="row " id="child-age-select'+room_var+col7+'"> '
						+'	</div>'
						+'	<div class="row " id="child-age-select'+room_var+col8+'">'
						+'	</div>'
						+'	<div class="row " id="child-age-select'+room_var+col9+'">'
						+'	</div>'
						+'</div>'
						+' </div>'
						
						// $('.mob-flight-container #child-age-grp').append($childAgeList);	
						// $('.mob-flight-container #child-age-select'+currentChild).append('<div class="col-lg-5 col-md-5 col-sm-5"><label class="booking-form--title1" for="childCount"> Child '+currentChild+'</label></div>'
						// +'<div class="col-lg-6 col-md-6 col-sm-6"><select id="childAgeInput'+currentChild+'" name="childAgeInput"><option value="0" selected>0 year</option><option value="1" selected>1 year</option><option value="2">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');
						$('#mob-enrich-earn-points--container #child-age-grp'+room_var).append($childAgeList);	
						$('#mob-enrich-earn-points--container #child-age-select'+room_var+currentChild).append('<div class="col-lg-5 col-md-5 col-sm-5"><label class="booking-form--title1" for="childCount"> Child '+currentChild+'</label></div>'
						+'<div class="col-lg-6 col-md-6 col-sm-6"><select id="childAgeInput'+currentChild+'" name="childAgeInput"><option value="2">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');

					}else{
						//Append box
						// $('.mob-flight-container #child-age-select'+currentChild).append('<div class="col-lg-5 col-md-5 col-sm-5"><label class="booking-form--title1" for="childCount"> Child '+currentChild+'</label></div>'
						// +'<div class="col-lg-6 col-md-6 col-sm-6"><select id="childAgeInput'+currentChild+'" name="childAgeInput"><option value="0" selected>0 year</option><option value="1" selected>1 year</option><option value="2">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');
						$('#mob-enrich-earn-points--container #child-age-select'+room_var+currentChild).append('<div class="col-lg-5 col-md-5 col-sm-5"><label class="booking-form--title1" for="childCount"> Child '+currentChild+'</label></div>'
						+'<div class="col-lg-6 col-md-6 col-sm-6"><select id="childAgeInput'+currentChild+'" name="childAgeInput"><option value="2" selected>2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');
					}
				}
				else{
					$('#mob-enrich-earn-points--container #child-age-select'+room_var+currentChild).append('');
				}
			}
		});

		// disable user input on field (next statement will no longer have any effect)
			curInstance.find('.minus-plus-input').attr('readonly', true);
		// store current value of input to data-attribute on focus
		// in case user manually edits fields
			_self.$instance.find('#mob-enrich-earn-points--container .minus-plus-input').focusin(function(){
				$(this).data('oldValue', $(this).val());
			});

		// on value increment/decrement, update old value data-attribute
		_self.$instance.find('#mob-enrich-earn-points--container .minus-plus-input').on('change', function() {
			let minValue     = parseInt($(this).attr('min'));
			let maxValue     = parseInt($(this).attr('max'));
			let valueCurrent = parseInt($(this).val());
			let name         = $(this).attr('name');
				if (valueCurrent >= minValue) {
					curInstance.find(".mobile-ticketnos--btn[data-type='minus'][data-field='"+name+"']").removeAttr('disabled')
				} else {
				$(this).data('oldValue',$(this).val());
				}
				if (valueCurrent <= maxValue) {
					curInstance.find(".mobile-ticketnos--btn[data-type='plus'][data-field='"+name+"']").removeAttr('disabled')
				} else {
				$(this).data('oldValue',$(this).val());
				}
				updatemobHotelTicketQtys();
			});

		// prevent input to passenger number field by keyboard
		// only allow change from pressing buttons
			_self.$instance.find('#mob-enrich-earn-points--container .minus-plus-input').keydown(function (e:any) {
				if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
					(e.keyCode == 65 && e.ctrlKey === true) ||
					(e.keyCode >= 35 && e.keyCode <= 39)) {
					return;
			}
			if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
				e.preventDefault();
			}
		});
		// run once on ready
		// _self.$instance.find('.minus-plus-input').trigger('change');
		updatemobHotelTicketQtys();

		/**
		 * calculate total ticket amount based on current values and populate display fields
		 * @return void
		 */
		function updatemobHotelTicketQtys() {
			let $passengerDetailsActive = curInstance.find('[mob-data-booking-passenger-details-selected]');

			$ticketAdultInput_roomf = parseInt($passengerDetailsActive.find('.ticket-mob-adult--input').val());
			$ticketAdultInput_rooms = parseInt($passengerDetailsActive.find('.ticket-mob-adult--input2').val());
			$ticketAdultInput_roomt = parseInt($passengerDetailsActive.find('.ticket-mob-adult--input3').val());
			$ticketChildInput_roomf = parseInt($passengerDetailsActive.find('.ticket-mob-child--input').val());
			$ticketChildInput_rooms = parseInt($passengerDetailsActive.find('.ticket-mob-child--input2').val());
			$ticketChildInput_roomt = parseInt($passengerDetailsActive.find('.ticket-mob-child--input3').val());
			// $ticketInfantInput_roomf = parseInt($passengerDetailsActive.find('.ticket-infant--input').val());
			// $ticketInfantInput_rooms = parseInt($passengerDetailsActive.find('.ticket-infant--input2').val());
			// $ticketInfantInput_roomt = parseInt($passengerDetailsActive.find('.ticket-infant--input3').val());	
			// get current values in input field and assign to method vars
			$ticketAdultInput = $ticketAdultInput_roomf +$ticketAdultInput_rooms + $ticketAdultInput_roomt;
			// $ticketInfantInput = $ticketInfantInput_roomf +$ticketInfantInput_rooms + $ticketInfantInput_roomt;
			$ticketChildInput = $ticketChildInput_roomf +$ticketChildInput_rooms + $ticketChildInput_roomt;


			// only adult, teenager and child tickets count towards limit
			$totalTickets = $ticketAdultInput  + $ticketChildInput;

			let $totalPassengersVal:any = $totalTickets;
			//let $totalPassenger:any 	  = curInstance.find('.total-passengers');
			let $totalTravelerDisplay:any = curInstance.find('.total-passengers');

			// update hidden input value for total tickets added
			// update display text for total tickets added
			_self.$instance.find('#mobile-enrichhotels--container .total-tickets--value').val($totalTickets);
			//$totalPassenger.find('.total-nos').html($totalPassengersVal);
			//$totalPassenger.find('.total-nos').html($totalPassengersVal);
			$('.mob-earn-enrich-hotels-passengers .total-nos').html($totalPassengersVal);

			if ($totalTickets >= 2) {
				$totalTravelerDisplay.find('.type').html('Travellers');
			} else {
				$totalTravelerDisplay.find('.type').html('Traveller');
			}

		
				// adult validations

				let $totalTickets_room1:number = $ticketAdultInput_roomf  + $ticketChildInput_roomf;
				let $totalTickets_room2:number = $ticketAdultInput_rooms  + $ticketChildInput_rooms;
				let $totalTickets_room3:number = $ticketAdultInput_roomt  + $ticketChildInput_roomt;

				if ($totalTickets_room1 == 5 || $totalTickets >= 5)
				{
				$('#mobroomone_earnenrichhoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', true);
				$('#mobroomone_earnenrichhoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', true);
				}
				else
				{
				$('#mobroomone_earnenrichhoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', false);
				$('#mobroomone_earnenrichhoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', false);
				}
				 if($totalTickets_room2 == 4 || $totalTickets >= 5)
				{
					$('#mobroomtwo_earnenrichhoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', true);
					$('#mobroomtwo_earnenrichhoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', true);
				}

				else
				{
					$('#mobroomtwo_earnenrichhoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', false);
					$('#mobroomtwo_earnenrichhoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', false);
				}
				if($totalTickets_room3 == 3 || $totalTickets >= 5)
				{
					$('#mobroomthre_earnenrichhoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', true);
					$('#mobroomthre_earnenrichhoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', true);
				}
				else
				{
					$('#mobroomthre_earnenrichhoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', false);
					$('#mobroomthre_earnenrichhoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', false);
				}
		}
	}


	populateTuiMobEnrichRedeemLocationList($scope: any): void {
		let _self = this;
		let $hotelInputVal: any;
		$(".mobEnrichHotelRedeemInputClass").attr('autocomplete', 'off');
		$scope.find('.mob-enrich-hotel-redeem-display-tui-container').on('mouseleave', function () {
			$(this).hide();
			$scope.find('.mobEnrichHotelRedeemInputClass').removeClass('hotel-input-boarder');
		});
		$(document).mouseup(function (event: any) {
			if ($(event.target).closest('.mob-enrich-hotel-redeem-display-tui-container').length
				=== 0) {
				$scope.find('.mob-enrich-hotel-redeem-display-tui-container').hide();
				$scope.find('.mobEnrichHotelRedeemInputClass').removeClass('hotel-input-boarder');
				if ($scope.find('#mobEnrichHotelRedeemInputVal').val() === '') {
					$scope.find('.mobEnrichHotelRedeemInputClass').val('');
					$scope.find('.mobEnrichHotelRedeemInputClass').removeClass('input-focused');
					// $('.booking-form--title', $scope.find('.mobEnrichHotelRedeemInputClass').parent()).removeClass('input-filled');
				}
			}
		});
		$scope.find('.mobEnrichHotelRedeemInputClass').keyup(_self.mobileDelay(function (e:any) {
			let trimSearchVal:any="";
			let searchTimeout:any=null;
			$hotelInputVal = $scope.find('.mobEnrichHotelRedeemInputClass').val();
			trimSearchVal=$hotelInputVal.split(" ").join("-");
			if ($hotelInputVal.length > 2) {
		
				$scope.find('.mob-enrich-hotel-redeem-display-tui-container').show();
				$scope.find('.mobEnrichHotelRedeemInputClass').addClass('hotel-input-boarder');
				let hotellisturl: string = '';
				if (window.location.hostname === 'localhost' && window.location.port == "5000") {
					hotellisturl = '/dummy-data/enrichHotelLocationList.json';
				}
				else {
					hotellisturl = '/bin/services/new/enrichhotellistsearchresult?cityName=' +trimSearchVal;
				}

				$.ajax({
					type: 'GET',
					url: hotellisturl,
					success: function (json: any) {
						if (window.location.hostname !== 'localhost') {
							json = JSON.parse(json);
						}
						_self.mobRedeemLocationlList($scope, json);
					},
					error: function (error: any) {
						console.log("Error while getting member info", error);
					}
				});
			

			}
		},500));

	}
	mobRedeemLocationlList($scope: any, response: any): any {
		let $hotelList: any = '';
		if (response.code=='200'&& response.results.length) {
			$hotelList += "<div class='hotel-tui-inner'>";
			// Object.keys(response).forEach(function(k){
			var itemCity = response.results;
			if (itemCity.length) {
				$hotelList += "<div class=' hotel-title'><span>Location</span></div>";
				Object.keys(itemCity).forEach(function (n) {

					$hotelList += "<div class='hotel-list' data-hotel" + itemCity[n].id + "= 'HotelID' id=hotel-opt" + n + " data-cityId='" + itemCity[n].id + "'  data-value='" + itemCity[n].name + "|" + itemCity[n].latitude + "," + itemCity[n].longitude + "'>" + itemCity[n]['description'] + "</div>";

				});
			}
			// });
			$hotelList += "</div>";
			$scope.find('.mob-enrich-hotel-redeem-display-tui-container').html($hotelList).text();
			$scope.find('.hotel-list').on('click', (evt: any) => {
				var evtVal = $('#' + evt.currentTarget.id).html();
				$scope.find('.mobEnrichHotelRedeemInputClass').focus();
				var evtValTextArray = evtVal.split('\u003cem\u003e');
				let getcityID: any = $('#' + evt.currentTarget.id).data('cityid');
				$scope.find('.mobEnrichHotelRedeemInputClass').val(evtValTextArray[0]);
				$scope.find('#mobEnrichHotelRedeemInputVal').val(evtValTextArray);
				$scope.find('#mobEnrichHotelRedeemInputtoVal').val(getcityID);
				// if($scope.selector == "#transferdrop"){
				// 	$scope.find('#geo-coords').val($('#'+evt.currentTarget.id).data('value').split('|')[1]);
				// }
				// if($scope.selector == "#transferpickup")
				// {
				// 	$scope.find('#geo-coords').val($('#'+evt.currentTarget.id).data('value').split('|')[1]);
				// }
				$scope.find('.mob-enrich-hotel-redeem-display-tui-container').hide();
				$scope.find('.mobEnrichHotelRedeemInputClass').removeClass('hotel-input-boarder');

				let $deptDateContainer = $scope.find('.dep-date');
				let $rtnDateContainer = $scope.find('.rtn-date');
				let $trvInfoContainer = $scope.find('.trv-info');

				$deptDateContainer.show();
				$rtnDateContainer.show();
				$trvInfoContainer.show();
				if ($scope.find('.mobEnrichHotelRedeemInputClass').val() !== '') {
					$scope.find('.departureDateMobile').focus();
					$('.departuretransferDate').focus();
					$scope.find('.departureDateMobile').focus();
				}
			});
		} else {
			$hotelList = "<div class='hotel-not'>No result found! </div>";
			$scope.find('.mob-enrich-hotel-redeem-display-tui-container').html($hotelList);
		}
	}
	/**
 * @function passengerDetailsEnrichHotelEarn
 * Passenger details container
 * !!! Properly scoped
 */


	mobPassengerDetailsEnrichHotelRedeem(): void {
		let _self = this;
		let $ticketAdultInput:number   = 1;
		//let $ticketYouthInput:number = 0;
		let $ticketChildInput:number   = 0;
		let $ticketInfantInput:number  = 0;
		let $totalTickets:number       = 1;
		let $totalPassenger:any 	  = _self.$instance.find('#mob-enrich-redeem-points--container .total-passengers');
		// adding room count
		let $ticketAdultInput_roomf:number  = 1;
		let $ticketAdultInput_rooms:number  = 1;
		let $ticketAdultInput_roomt:number  = 1;
		let $ticketChildInput_roomf:number  = 0;
		let $ticketChildInput_rooms:number  = 0;
		let $ticketChildInput_roomt:number  = 0;
		// let $ticketInfantInput_roomf:number  = 0;
		// let $ticketInfantInput_rooms:number  = 0;
		// let $ticketInfantInput_roomt:number  = 0;

		let curInstance = _self.$instance.find('#mob-enrich-redeem-points--container'); // assign current instance to var as later requests will call latest assigned instance
		let $groupBooking     = curInstance.find('.group-booking');

		$totalPassenger.find('.total-nos').html($totalTickets);
		_self.$instance.find('#mob-enrich-redeem-points--container input.total-tickets--value').val($totalTickets);

		$('#mob-enrich-redeem-points--container .close-bookingroom_hotelmob2').on('click', () => {
				if ($("#mobroomthre_redeemenrichhoteldetails").hasClass('hide'))
				{
					$('#mobroomtwo_redeemenrichhoteldetails').addClass('hide');
					$('#mob-enrich-redeem-points--container .ticket-mob-adult--input2').val('0');
					$('#mob-enrich-redeem-points--containerr .ticket-infant--input2').val('0');
					$('#mob-enrich-redeem-points--container.ticket-mob-child--input2').val('0');
					$('#mobroomtwo_redeemenrichhoteldetails').find('.booking-ticket--nosr').remove();
					$('#mob-enrich-redeem-points--container .close-bookingroom_hotelmob2').addClass('hide');
					updatemobHotelTicketQtys();
				}
				$('#mob-enrich-redeem-points--container .add_roomshotel').show();
			});
			$('#mob-enrich-redeem-points--container .close-bookingroom_hotelmob3').on('click', () => {
				$('#mobroomthre_redeemenrichhoteldetails').addClass('hide');
				$('#mob-enrich-redeem-points--container .add_roomshotel').show();
				$('#mob-enrich-redeem-points--container .ticket-mob-adult--input3').val('0');
				$('#mob-enrich-redeem-points--container .ticket-infant--input3').val('0');
				$('#mob-enrich-redeem-points--container .ticket-mob-child--input3').val('0');
				$('#mobroomthre_redeemenrichhoteldetails').find('.booking-ticket--nosr').remove();
				$('#mob-enrich-redeem-points--container .close-bookingroom_hotelmob2').removeClass('hide');
				updatemobHotelTicketQtys();
			});

			_self.$instance.find('#mob-enrich-redeem-points--container .add_roomshotel').on('click', function(e:any) {
				e.preventDefault();
				if ($("#mobroomtwo_redeemenrichhoteldetails").hasClass('hide') && $totalTickets < 5)
				{
					$('#mobroomtwo_redeemenrichhoteldetails').css({'display': 'block' });;
					$('#mobroomtwo_redeemenrichhoteldetails').removeClass('hide');
					$('.ticket-mob-adult--input2').val('1');
					$('#mob-enrich-redeem-points--container .close-bookingroom_hotelmob2').removeClass('hide');
					curInstance.find('.booking-ticket--nos .age-label').show();
					_self.$instance.find('[mob-data-booking-passenger-details-selected]').show();
					updatemobHotelTicketQtys();
				}
			else if ($("#mobroomthre_redeemenrichhoteldetails").hasClass('hide') && $totalTickets <5) 
				{
					$('#mobroomthre_redeemenrichhoteldetails').removeClass('hide');
					$('#mobroomthre_redeemenrichhoteldetails').css({'display': 'block' });;
					curInstance.find('.booking-ticket--nos .age-label').show();
					$('#mob-enrich-redeem-points--container .close-bookingroom_hotelmob2').addClass('hide');
					$('.ticket-mob-adult--input3').val('1');
					$('#mob-enrich-redeem-points--container .add_roomshotel').hide();
					updatemobHotelTicketQtys();
				}

			});
		_self.$instance.find('#mob-enrich-redeem-points--container .mobile-ticketnos--btn').on('click', function(e:any){
			e.preventDefault();
			let $passengerDetailsActive:any = curInstance.find('[mob-data-booking-passenger-details-selected]');

			// declare passenger input variables
			// scope them to prevent multiple elements from being retrieved
			// (deals component uses the same class name for its inputs)
			let $adultInput  = $passengerDetailsActive.find('.ticket-mob-adult--input');
			let $infantInput = $passengerDetailsActive.find('.ticket-mob-infant--input');
			let $childInput = $passengerDetailsActive.find('.ticket-mob-child--input');
			// let $youthInput  = _self.$passengerDetailsActive.find('.ticket-mob-youth--input');

			let $adultBookingErr  = curInstance.find('.adult-booking--error---mobile');
			let $infantBookingErr = curInstance.find('.infant-booking--error---mobile');


			// get currently acted on input field
			var fieldName   = $(this).attr('data-field'),
			type        = $(this).attr('data-type'),
			input       = curInstance.find("input[name='"+fieldName+"']"),
			currentVal   = parseInt(input.val());

			// apply calculation to acted-on field (plus/minus)
			if (!isNaN(currentVal)) {
					input.data('oldValue', currentVal);
				if (type == 'minus') {
							if (currentVal > parseInt(input.attr('min'))) {
									input.val(currentVal - 1);
									input.trigger('change');
					}
							if (parseInt(input.val()) == parseInt(input.attr('min'))) {
									$(this).attr('disabled', true);
							}
				} else if (type == 'plus') {
					if (currentVal < input.attr('max')) {
									input.val(currentVal + 1);
									input.trigger('change');
					}
					if (parseInt(input.val()) == input.attr('max')) {
						$(this).attr('disabled', true);
					}
				}
			} else {
				input.val(0);
			}
			if (!isNaN(currentVal) && fieldName=="passengersChildren"||fieldName=="passengersChildren2"||fieldName=="passengersChildren3") {
				// show age box if hide
				let room_var=fieldName;
				var currentChild = currentVal+1;
				var currentChildmnus = currentVal-1;
				//flight-container
				$('#mob-enrich-redeem-points--container .child-age-grp'+room_var).show();
				// $('.mob-flight-container .child-age-grp').show();
				if (type == 'minus') {
					if(currentChildmnus%8 ==0){
						$( "#mob-enrich-redeem-points--container #child-age-col"+room_var+currentChildmnus ).remove();
						// $( ".mob-hotel-container #child-age-col"+currentChildmnus ).remove();

					}else{
						//Append box
						$('#mob-enrich-redeem-points--container #child-age-select'+room_var+currentVal).empty();
						// $('.mob-flight-container #child-age-select'+currentVal).empty();
					}
				} else if (type == 'plus') {
					if(currentVal%8 ==0){
						// Append column
						let ageLabel ='';
						let errorChildAge ='';
						if(currentChild == 1){
							ageLabel ='Age';
							errorChildAge ='<div class="child-age-error" data-childage-limit-mob="Child age must be between 2 and 12" data-childage="Child age is missing" style="display: none;">Please enter child age</div>';
						}
						var col1 =currentChild;
						var col2 =currentChild+1;
						var col3 =currentChild+2;
						var col3 =currentChild+2;
						var col4 =currentChild+3;
						var col5 =currentChild+4;
						var col6 =currentChild+5;
						var col7 =currentChild+6;
						var col8 =currentChild+7;
						var col9 =currentChild+9
						let $childAgeList ='<div class="col-lg-12 col-md-12 col-sm-12" id="child-age-col'+room_var+currentVal+'">'
						+'<div class="col-lg-12 col-md-12 col-sm-12 booking-ticket--nosr adult-nos child-age-drp"> <div class="child-age-label">Age of Children</div>'
						+ errorChildAge
						+'	<div class="row" id="child-age-select'+room_var+col1+'">'
						+'	</div>'
						+'	<div class="row" id="child-age-select'+room_var+col2+'"> '
						+'	</div>'
						+'	<div class="row" id="child-age-select'+room_var+col3+'">'
						+'	</div>'
						+'	<div class="row " id="child-age-select'+room_var+col4+'">'
						+'	</div>'
						+'	<div class="row " id="child-age-select'+room_var+col5+'"> '
						+'	</div>'
						+'	<div class="row " id="child-age-select'+room_var+col6+'">'
						+'	</div>'
						+'	<div class="row " id="child-age-select'+room_var+col7+'"> '
						+'	</div>'
						+'	<div class="row " id="child-age-select'+room_var+col8+'">'
						+'	</div>'
						+'	<div class="row " id="child-age-select'+room_var+col9+'">'
						+'	</div>'
						+'</div>'
						+' </div>'
						
						// $('.mob-flight-container #child-age-grp').append($childAgeList);	
						// $('.mob-flight-container #child-age-select'+currentChild).append('<div class="col-lg-5 col-md-5 col-sm-5"><label class="booking-form--title1" for="childCount"> Child '+currentChild+'</label></div>'
						// +'<div class="col-lg-6 col-md-6 col-sm-6"><select id="childAgeInput'+currentChild+'" name="childAgeInput"><option value="0" selected>0 year</option><option value="1" selected>1 year</option><option value="2">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');
						$('#mob-enrich-redeem-points--container #child-age-grp'+room_var).append($childAgeList);	
						$('#mob-enrich-redeem-points--container #child-age-select'+room_var+currentChild).append('<div class="col-lg-5 col-md-5 col-sm-5"><label class="booking-form--title1" for="childCount"> Child '+currentChild+'</label></div>'
						+'<div class="col-lg-6 col-md-6 col-sm-6"><select id="childAgeInput'+currentChild+'" name="childAgeInput"><option value="2">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');

					}else{
						//Append box
						// $('.mob-flight-container #child-age-select'+currentChild).append('<div class="col-lg-5 col-md-5 col-sm-5"><label class="booking-form--title1" for="childCount"> Child '+currentChild+'</label></div>'
						// +'<div class="col-lg-6 col-md-6 col-sm-6"><select id="childAgeInput'+currentChild+'" name="childAgeInput"><option value="0" selected>0 year</option><option value="1" selected>1 year</option><option value="2">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');
						$('#mob-enrich-redeem-points--container #child-age-select'+room_var+currentChild).append('<div class="col-lg-5 col-md-5 col-sm-5"><label class="booking-form--title1" for="childCount"> Child '+currentChild+'</label></div>'
						+'<div class="col-lg-6 col-md-6 col-sm-6"><select id="childAgeInput'+currentChild+'" name="childAgeInput"><option value="2" selected>2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');
					}
				}
				else{
					$('#mob-enrich-redeem-points--container #child-age-select'+room_var+currentChild).append('');
				}
			}
		});

		// disable user input on field (next statement will no longer have any effect)
			curInstance.find('.minus-plus-input').attr('readonly', true);
		// store current value of input to data-attribute on focus
		// in case user manually edits fields
			_self.$instance.find('#mob-enrich-redeem-points--container .minus-plus-input').focusin(function(){
				$(this).data('oldValue', $(this).val());
			});

		// on value increment/decrement, update old value data-attribute
		_self.$instance.find('#mob-enrich-redeem-points--container .minus-plus-input').on('change', function() {
			let minValue     = parseInt($(this).attr('min'));
			let maxValue     = parseInt($(this).attr('max'));
			let valueCurrent = parseInt($(this).val());
			let name         = $(this).attr('name');
				if (valueCurrent >= minValue) {
					curInstance.find(".mobile-ticketnos--btn[data-type='minus'][data-field='"+name+"']").removeAttr('disabled')
				} else {
				$(this).data('oldValue',$(this).val());
				}
				if (valueCurrent <= maxValue) {
					curInstance.find(".mobile-ticketnos--btn[data-type='plus'][data-field='"+name+"']").removeAttr('disabled')
				} else {
				$(this).data('oldValue',$(this).val());
				}
				updatemobHotelTicketQtys();
			});

		// prevent input to passenger number field by keyboard
		// only allow change from pressing buttons
			_self.$instance.find('#mob-enrich-redeem-points--container .minus-plus-input').keydown(function (e:any) {
				if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
					(e.keyCode == 65 && e.ctrlKey === true) ||
					(e.keyCode >= 35 && e.keyCode <= 39)) {
					return;
			}
			if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
				e.preventDefault();
			}
		});
		// run once on ready
		// _self.$instance.find('.minus-plus-input').trigger('change');
		updatemobHotelTicketQtys();

		/**
		 * calculate total ticket amount based on current values and populate display fields
		 * @return void
		 */
		function updatemobHotelTicketQtys() {
			let $passengerDetailsActive = curInstance.find('[mob-data-booking-passenger-details-selected]');

			$ticketAdultInput_roomf = parseInt($passengerDetailsActive.find('.ticket-mob-adult--input').val());
			$ticketAdultInput_rooms = parseInt($passengerDetailsActive.find('.ticket-mob-adult--input2').val());
			$ticketAdultInput_roomt = parseInt($passengerDetailsActive.find('.ticket-mob-adult--input3').val());
			$ticketChildInput_roomf = parseInt($passengerDetailsActive.find('.ticket-mob-child--input').val());
			$ticketChildInput_rooms = parseInt($passengerDetailsActive.find('.ticket-mob-child--input2').val());
			$ticketChildInput_roomt = parseInt($passengerDetailsActive.find('.ticket-mob-child--input3').val());
			// $ticketInfantInput_roomf = parseInt($passengerDetailsActive.find('.ticket-infant--input').val());
			// $ticketInfantInput_rooms = parseInt($passengerDetailsActive.find('.ticket-infant--input2').val());
			// $ticketInfantInput_roomt = parseInt($passengerDetailsActive.find('.ticket-infant--input3').val());	
			// get current values in input field and assign to method vars
			$ticketAdultInput = $ticketAdultInput_roomf +$ticketAdultInput_rooms + $ticketAdultInput_roomt;
			// $ticketInfantInput = $ticketInfantInput_roomf +$ticketInfantInput_rooms + $ticketInfantInput_roomt;
			$ticketChildInput = $ticketChildInput_roomf +$ticketChildInput_rooms + $ticketChildInput_roomt;


			// only adult, teenager and child tickets count towards limit
			$totalTickets = $ticketAdultInput  + $ticketChildInput;

			let $totalPassengersVal:any = $totalTickets;
			//let $totalPassenger:any 	  = curInstance.find('.total-passengers');
			let $totalTravelerDisplay:any = curInstance.find('.total-passengers');

			// update hidden input value for total tickets added
			// update display text for total tickets added
			_self.$instance.find('#mobile-enrichhotels--container .total-tickets--value').val($totalTickets);
			//$totalPassenger.find('.total-nos').html($totalPassengersVal);
			//$totalPassenger.find('.total-nos').html($totalPassengersVal);
			$('.mob-redeem-enrich-hotels-passengers .total-nos').html($totalPassengersVal);

			if ($totalTickets >= 2) {
				$totalTravelerDisplay.find('.type').html('Travellers');
			} else {
				$totalTravelerDisplay.find('.type').html('Traveller');
			}

		
				// adult validations

				let $totalTickets_room1:number = $ticketAdultInput_roomf  + $ticketChildInput_roomf;
				let $totalTickets_room2:number = $ticketAdultInput_rooms  + $ticketChildInput_rooms;
				let $totalTickets_room3:number = $ticketAdultInput_roomt  + $ticketChildInput_roomt;

				if ($totalTickets_room1 == 5 || $totalTickets >= 5)
				{
				$('#mobroomone_redeemenrichhoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', true);
				$('#mobroomone_redeemenrichhoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', true);
				}
				else
				{
				$('#mobroomone_redeemenrichhoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', false);
				$('#mobroomone_redeemenrichhoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', false);
				}
				 if($totalTickets_room2 == 4 || $totalTickets >= 5)
				{
					$('#mobroomtwo_redeemenrichhoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', true);
					$('#mobroomtwo_redeemenrichhoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', true);
				}

				else
				{
					$('#mobroomtwo_redeemenrichhoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', false);
					$('#mobroomtwo_redeemenrichhoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', false);
				}
				if($totalTickets_room3 == 3 || $totalTickets >= 5)
				{
					$('#mobroomthre_redeemenrichhoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', true);
					$('#mobroomthre_redeemenrichhoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', true);
				}
				else
				{
					$('#mobroomthre_redeemenrichhoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', false);
					$('#mobroomthre_redeemenrichhoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', false);
				}
		}

	}
	/**
	 * @function passengerType
	 * IBE Passenger type container
	 * !!! Properly scoped
	 */
	passengerTypeMob(): void {
		let _self = this;

		let $passengerDetails: any = _self.$instance.find('[mob-data-booking-passenger-details]');
		let $passengerDetailsActive: any = _self.$instance.find('[mob-data-booking-passenger-details-selected]');
		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance

		$passengerDetails.on('click', () => {
			$(this).hide();
			$passengerDetailsActive.show();
			curInstance.find('.book-date--selector').removeClass('datepicker-selected');
		});

		$passengerDetailsActive.mouseleave((evt: any) => {
			if (evt.relatedTarget != null) {
				$(this).hide();
				$passengerDetailsActive.hide();
				$passengerDetails.addClass('passenger-focused');
				$passengerDetails.show();
				$passengerDetails.find('.total-passengers').show();
			}
		});

		$passengerDetailsActive.on('touchend', function (e: any) {
			if (!($(e.target).closest('.booking-person').length || $(e.target).is('.booking-person'))) {
				$passengerDetailsActive.hide();
				return false;
			} else {
				return true;
			}
		});
	}
	// enrichpoints tabs hide/show start
	initCalendar(): void {
		let _self = this;
		let nowDate: any = new Date();
		let today: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate(), 0, 0, 0, 0);
		let $ibeMHHMindays: any = $('[data-mhh-min-days]').length > 0 ? parseInt($('[data-mhh-min-days]').attr('data-mhh-min-days')) : 0;
		let tomorrow: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + $ibeMHHMindays, 0, 0, 0, 0);
		// let depRange: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + 184, 0, 0, 0, 0);
		let depRange = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + parseInt($('#mobile-enrichhotels--container .departureDateMobile').attr('data-datepicker-days')), 0, 0, 0, 0);
		let retRange: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + 0, 0, 0, 0, 0);
		let maxLimitDate: any = new Date(nowDate.getFullYear() + 1, nowDate.getMonth(), nowDate.getDate(), 0, 0, 0, 0);
		let $curDatepickerInst:any;
		let $curDatepickerTitle:string;


		function highlightDays(date: any) {
			var startDate = new Date($("#searchFlightDepart").datepicker("getDate"));
			var endDate = new Date($("#searchFlightReturn").datepicker("getDate"));

			if ((startDate <= date) && (date <= endDate)) {
				return [true, 'highlight'];
			} else {
				return [true, ''];
			}
		}
		let $dateFormat: any = 'd M yy',
			$departDate = _self.$scopeMob.find('.departureDateMobile')

				.datepicker({
					showButtonPanel: true,
					minDate: tomorrow,
					closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
					dateFormat: 'd M yy',
					numberOfMonths: 2,
					maxDate: depRange,
					onClose: function (selectedDate: any) {
						let nextDay: any = new Date(selectedDate);
						let depDate: any;
						depRange = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + parseInt($('#mobile-enrichhotels--container .departureDateMobile').attr('data-datepicker-days')), 0, 0, 0, 0);
						$('#mobile-enrichhotels--container .returnDateMobile').datepicker("option", "minDate", ((selectedDate && selectedDate != '') ? nextDay : tomorrow));
						if(getDate($('#mob-enrich-earn-points--container .departureDateMobile')[0])){
							depDate = getDate($('#mob-enrich-earn-points--container .departureDateMobile')[0]);
							if (selectedDate == '') {
								$('.returnDateMobile').datepicker('option', 'maxDate', depRange);
							} else {
								$('.returnDateMobile').datepicker('option', 'maxDate', new Date(depDate.getFullYear(), depDate.getMonth(), depDate.getDate() + 30, 0, 0, 0, 0));
							}
						}
						else if(getDate($('#mob-enrich-redeem-points--container .departureDateMobile')[0])){
							depDate = getDate($('#mob-enrich-redeem-points--container .departureDateMobile')[0]);
							if (selectedDate == '') {
								$('.returnDateMobile').datepicker('option', 'maxDate', depRange);
							} else {
								$('.returnDateMobile').datepicker('option', 'maxDate', new Date(depDate.getFullYear(), depDate.getMonth(), depDate.getDate() + 30, 0, 0, 0, 0));
							}
						}
					},
					beforeShow: function(ele:any, obj:any) {
						_self.$instance.find('#ui-datepicker-div').removeClass('multicityTrip');
						_self.bcommon.appendDatepickerTitle('Please select your return date', obj.dpDiv);
						$curDatepickerInst  = obj.dpDiv[0];
						$curDatepickerTitle = ele.dataset.datepickerTitle;
					},
					afterShow: function() {
						_self.bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
					}
				})
				.on('change', function () {
					//$returnDate.datepicker('option', 'minDate', getDate(this));
					$returnDate.datepicker('setDate', null);
					let $nextReturnDate: any = $('.returnDateMobile');
					if ($nextReturnDate.val() === "") {
						window.setTimeout($.proxy(function () {
							$nextReturnDate.focus();
						}, this), 100);
					}
					if ($('.departureDateMobile').val() != '') {
						$('.departureDateMobile').removeClass('has-empty-error');
					}
				}),
			$returnDate = _self.$scopeMob.find('.returnDateMobile')
				.datepicker({
					showButtonPanel: true,
					minDate: tomorrow,
					closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
					dateFormat: 'd M yy',
					numberOfMonths: 2,
					maxDate: $departDate + 30,
					beforeShow: function(ele:any, obj:any) {
						_self.$instance.find('#ui-datepicker-div').removeClass('multicityTrip');
						_self.bcommon.appendDatepickerTitle('Please select your return date', obj.dpDiv);
						$curDatepickerInst  = obj.dpDiv[0];
						$curDatepickerTitle = ele.dataset.datepickerTitle;
					},
					afterShow: function() {
						_self.bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
					}
				})
				.on('change', function () {
					if ($('.returnDateMobile').val() != '') {
						$('.returnDateMobile').removeClass('has-empty-error');
					}
					$('.passenger-details-selected').show();
				});

		let getDate: any = ($element: any) => {
			let $getDate: any;
			try {
				$getDate = $.datepicker.parseDate($dateFormat, $element.value);
			} catch (error) {
				$getDate = null;
			}
			return $getDate;
		}
		let depRangeFlight: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + parseInt($('#mobile-enrichhotels--container .departureDateMobile').attr('data-datepicker-days')), 0, 0, 0, 0);
		let depRangeHotel: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + parseInt($('#mobile-enrichhotels--container .departureDateMobile').attr('data-datepicker-days')), 0, 0, 0, 0);
		$('#mobile-enrichhotels--container .departureDateMobile').datepicker('option', 'maxDate', depRangeHotel);
		$('#mobile-enrichhotels--container .returnDateMobile').datepicker('option', 'maxDate', depRangeHotel);
		$('#mobile-enrichhotels--container .departureDateMobile').datepicker('option', 'maxDate', depRangeFlight);
		$('#mobile-enrichhotels--container .returnDateMobile').datepicker('option', 'maxDate', depRangeFlight);
	}
	/**
 * @function ibeSingleFormSubmitHandler
 * !!! Properly scoped
 */
	mobEnrichFormSubmitHandler(): void {
		let _self = this;

		let $errorValidation = _self.$instance.find('.enrich-validation').first();
		// let $singleTripSubmitBtn:any    = _self.$instance.find('.mholidays-single-city--bookflight');
		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance
		let $enrichHotelEarnSubmitBtn: any = _self.$instance.find('.mob-enrich-earn-book-hotel');
		let $enrichHotelRdeemSubmitBtn: any = _self.$instance.find('.mob-enrich-redeem-book-hotel');


		//if (!(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) )) {
		// _self.getOfficeCode();

		$enrichHotelEarnSubmitBtn.on('click', (evt: any) => {
			this.$error = [];
			evt.preventDefault();
			let ieversion = new headerContent();
			ieversion.checkIEVersion_disablePupup();
			$errorValidation.show();
			_self.bookingFormSubmit.mobEnrichHotelEarnFormValidation(curInstance, function ($officeCode: any) {
				_self.bookingFormSubmit.mobEnrichHotelEarnDeeplink(curInstance);

			});

		});
		$enrichHotelRdeemSubmitBtn.on('click', (evt: any) => {
			this.$error = [];
			evt.preventDefault();
			let ieversion = new headerContent();
			ieversion.checkIEVersion_disablePupup();
			$errorValidation.show();
			_self.bookingFormSubmit.mobEnrichHotelRedeemFormValidation(curInstance, function ($officeCode: any) {
				_self.bookingFormSubmit.mobEnrichHotelRedeemDeeplink(curInstance);

			});

		});

		//}
	}
	mobEarnRoomPassengerDetails($scope:any): void {
		let _self = this;
		let $ticketRoomInput:number  = 1;
		let $ticketAdultInput:number  = 1;
		let $ticketChildInput:number  = 0;
		let $ticketInfantInput:number = 0;
		let $totalTickets:number      = 1;
		let $totalRooms:number      = 1;
		let $ticketTeenagerInput: number = 0;
		let $totalPassenger:any 	  = _self.$scopeMob.find('#mob-enrich-earn-points--container .total-passengers');
		let $totalRoom:any 	  = _self.$scopeMob.find('#mob-enrich-earn-points--container .total-rooms');
		let curInstance = _self.$instance.find('#mob-enrich-earn-points--container'); // assign current instance to var as later requests will call latest assigned instance
		// let $groupBooking = curInstance.find('.group-booking');
		// let $isEnableNinePass: any	=	$('#isEnableNinePass');
 
		// $groupBooking.hide();

		// let $ticketYouthInput:number  = 0;

		_self.$scopeMob.find('#mob-enrich-earn-points--container .total-nos').html($totalTickets);
		_self.$scopeMob.find('#mob-enrich-earn-points--container .total-nos-rooms').html($totalRooms);

	

		_self.$instance.find('#mob-enrich-earn-points--container .mobile-ticketnos--btn').on('click', function(e:any) {
			e.preventDefault();

			// get currently acted on input field
			var fieldName  = $(this).attr('data-field'),
					type       = $(this).attr('data-type'),
					input      = curInstance.find("input[name='"+fieldName+"']"),
					currentVal = parseInt(input.val());

			// apply calculation to acted-on field (plus/minus)
			if (!isNaN(currentVal)) {
					input.data('oldValue', currentVal);
					if (type == 'minus') {
			
							if (currentVal > parseInt(input.attr('min'))) {
									input.val(currentVal - 1);
									input.trigger('change');
							}
							if (parseInt(input.val()) == parseInt(input.attr('min'))) {
									$(this).attr('disabled', true);
							}
							if(fieldName== "passengersRoom"){
								if(currentVal>$('#mob-enrich-earn-points--container .ticket-mob-adult--input').val())
								$('#mob-enrich-earn-points--container .ticket-mob-adult--input').val(currentVal - 1);
							}
							if(fieldName== "passengersAdult"){
								if(currentVal<=$('#mob-enrich-earn-points--container .ticket-mob-room--input').val()){
									$('#mob-enrich-earn-points--container .ticket-mob-room--input').val(currentVal - 1);
								}
							}
				
					} else if (type == 'plus') {
							if (currentVal < input.attr('max')) {
									input.val(currentVal + 1);
									input.trigger('change');
							}
							if (parseInt(input.val()) == input.attr('max')) {
									$(this).attr('disabled', true);
							}
							if(fieldName== "passengersRoom"){			
								if(currentVal>= $('#mob-enrich-earn-points--container .ticket-mob-adult--input').val()){
									$('#mob-enrich-earn-points--container .ticket-mob-adult--input').val(currentVal + 1);
								}
							}
							if(fieldName== "passengersAdult"){
								if(currentVal<$('#mob-enrich-earn-points--container .ticket-mob-room--input').val()){
									$('#mob-enrich-earn-points--container .ticket-mob-room--input').val(currentVal + 1);
								}
							}
				
					}
			} else {
					input.val(0);
			}
		
			updateTicketQtys();
		});

		// disable user input on field (next statement will no longer have any effect)
		_self.$instance.find('#mob-enrich-earn-points--container .minus-plus-input').attr('readonly', true);

		// store current value of input to data-attribute on focus
		// in case user manually edits fields
		_self.$instance.find('#mob-enrich-earn-points--container .minus-plus-input').on('focusin', function() {
			 $(this).data('oldValue', $(this).val());
		});
		// cabin class on change
		$('.cabin-class').on('change', function() {
			if($('.ibe_freesidetrip').is(":visible")) 
					{
					$('.ibe_freesidetrip').hide();					
					$('.single-city--bookflight').show();
					}		
		});
		// on value increment/decrement, update old value data-attribute
		_self.$instance.find('#mob-enrich-earn-points--container .minus-plus-input').on('change', function() {
			// adultInfantValidation();

			let minValue     = parseInt($(this).attr('min'));
			let maxValue     = parseInt($(this).attr('max'));
			let valueCurrent = parseInt($(this).val());
			let name         = $(this).attr('name');

			if (valueCurrent >= minValue) {
				curInstance.find(".mobile-ticketnos--btn[data-type='minus'][data-field='"+name+"']").removeAttr('disabled');
			} else {
				$(this).data('oldValue',$(this).val());
			}

			if (valueCurrent <= maxValue) {
				curInstance.find(".mobile-ticketnos--btn[data-type='plus'][data-field='"+name+"']").removeAttr('disabled');
			} else {
				$(this).data('oldValue',$(this).val());
			}
			updateTicketQtys();
		});

		// prevent input to passenger number field by keyboard
		// only allow change from pressing buttons
		_self.$instance.find('#mob-enrich-earn-points--container .minus-plus-input').on('keydown', function (e:any) {
			if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
				(e.keyCode == 65 && e.ctrlKey === true) ||
				(e.keyCode >= 35 && e.keyCode <= 39)) {
				return;
			}
			if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
				e.preventDefault();
			}
		});

		// run once on ready
		// _self.$instance.find('.minus-plus-input').trigger('change');
		// updateTicketQtys();

		/**
		 * calculate total ticket amount based on current values and populate display fields
		 * @return void
		 */
		function updateTicketQtys() {
			let $passengerDetailsActive = curInstance.find('[mob-data-booking-passenger-details-selected]');

			// get current values in input field and assign to method vars
			$ticketRoomInput = parseInt($passengerDetailsActive.find('.ticket-mob-room--input').val());
			$ticketAdultInput = parseInt($passengerDetailsActive.find('.ticket-mob-adult--input').val());
			$ticketChildInput = parseInt($passengerDetailsActive.find('.ticket-mob-child--input').val());


			// only adult and child tickets count towards limit 
			$totalTickets = $ticketAdultInput + $ticketChildInput;
			$totalRooms =$ticketRoomInput;
			let $totalPassengersVal: any = $totalTickets 
			let $totalRoomsVal: any = $totalRooms 
			let $totalPassenger: any = curInstance.find('.total-passengers');
		

			// update hidden input value for total tickets added
			// update display text for total tickets added
			_self.$instance.find('#mob-enrich-earn-points--container .total-tickets--value').val($totalTickets);
			$totalPassenger.find('.total-nos').html($totalPassengersVal);
			$totalPassenger.find('.total-nos-rooms').html($totalRoomsVal);
			let $totalTravelerDisplay: any = curInstance.find('.total-passengers');
			if ($totalTickets >= 2) {
				//$totalPassengerDisplay.find('.type').html('Passengers');
				$totalTravelerDisplay.find('.type').html('Guests');
			} else {
				//$totalPassengerDisplay.find('.type').html('Passenger');
				$totalTravelerDisplay.find('.type').html('Guest');
			}

			if ($totalRooms >= 2) {
				//$totalPassengerDisplay.find('.type').html('Passengers');
				$totalTravelerDisplay.find('.typeRoom').html('Rooms');
			} else {
				//$totalPassengerDisplay.find('.type').html('Passenger');
				$totalTravelerDisplay.find('.typeRoom').html('Room');
			}


			if ($totalTickets >= 5) {
				curInstance.find('.room-nos .input-group--btn .plus').attr('disabled', true);
				curInstance.find('.adult-nos .input-group--btn .plus').attr('disabled', true);
				curInstance.find('.child-nos .input-group--btn .plus').attr('disabled', true);
			} else {
				curInstance.find('.room-nos .input-group--btn .plus').attr('disabled', false);
				curInstance.find('.adult-nos .input-group--btn .plus').attr('disabled', false);
				curInstance.find('.child-nos .input-group--btn .plus').attr('disabled', false);
			}
			if($ticketRoomInput>=3){
				curInstance.find('.room-nos .input-group--btn .plus').attr('disabled', true);
			}
		

		}

	}

	mobRedeemRoomPassengerDetails($scope:any): void {
		let _self = this;
		let $ticketRoomInput:number  = 1;
		let $ticketAdultInput:number  = 1;
		let $ticketChildInput:number  = 0;
		let $ticketInfantInput:number = 0;
		let $totalTickets:number      = 1;
		let $totalRooms:number      = 1;
		let $ticketTeenagerInput: number = 0;
		let $totalPassenger:any 	  = _self.$scopeMob.find('#mob-enrich-redeem-points--container .total-passengers');
		let $totalRoom:any 	  = _self.$scopeMob.find('#mob-enrich-redeem-points--container .total-rooms');
		let curInstance = _self.$instance.find('#mob-enrich-redeem-points--container'); // assign current instance to var as later requests will call latest assigned instance
		// let $groupBooking = curInstance.find('.group-booking');
		// let $isEnableNinePass: any	=	$('#isEnableNinePass');
 
		// $groupBooking.hide();

		// let $ticketYouthInput:number  = 0;

		_self.$scopeMob.find('#mob-enrich-redeem-points--container .total-nos').html($totalTickets);
		_self.$scopeMob.find('#mob-enrich-redeem-points--container .total-nos-rooms').html($totalRooms);

	

		_self.$instance.find('#mob-enrich-redeem-points--container .mobile-ticketnos--btn').on('click', function(e:any) {
			e.preventDefault();

			// get currently acted on input field
			var fieldName  = $(this).attr('data-field'),
					type       = $(this).attr('data-type'),
					input      = curInstance.find("input[name='"+fieldName+"']"),
					currentVal = parseInt(input.val());

			// apply calculation to acted-on field (plus/minus)
			if (!isNaN(currentVal)) {
					input.data('oldValue', currentVal);
					if (type == 'minus') {
			
							if (currentVal > parseInt(input.attr('min'))) {
									input.val(currentVal - 1);
									input.trigger('change');
							}
							if (parseInt(input.val()) == parseInt(input.attr('min'))) {
									$(this).attr('disabled', true);
							}
							if(fieldName== "passengersRoom"){
								if(currentVal>$('#mob-enrich-redeem-points--container .ticket-mob-adult--input').val())
								$('#mob-enrich-redeem-points--container .ticket-mob-adult--input').val(currentVal - 1);
							}
							if(fieldName== "passengersAdult"){
								if(currentVal<=$('#mob-enrich-redeem-points--container .ticket-mob-room--input').val()){
									$('#mob-enrich-redeem-points--container .ticket-mob-room--input').val(currentVal - 1);
								}
							}
				
					} else if (type == 'plus') {
							if (currentVal < input.attr('max')) {
									input.val(currentVal + 1);
									input.trigger('change');
							}
							if (parseInt(input.val()) == input.attr('max')) {
									$(this).attr('disabled', true);
							}
							if(fieldName== "passengersRoom"){							
								if(currentVal>= $('#mob-enrich-redeem-points--container .ticket-mob-adult--input').val()){
									$('#mob-enrich-redeem-points--container .ticket-mob-adult--input').val(currentVal + 1);
								}
							}
							if(fieldName== "passengersAdult"){
								if(currentVal<$('#mob-enrich-redeem-points--container .ticket-mob-room--input').val()){
									$('#mob-enrich-redeem-points--container .ticket-mob-room--input').val(currentVal + 1);
								}
							}
				
					}
			} else {
					input.val(0);
			}
		
			updateTicketQtys();
		});

		// disable user input on field (next statement will no longer have any effect)
		_self.$instance.find('#mob-enrich-redeem-points--container .minus-plus-input').attr('readonly', true);

		// store current value of input to data-attribute on focus
		// in case user manually edits fields
		_self.$instance.find('#mob-enrich-redeem-points--container .minus-plus-input').on('focusin', function() {
			 $(this).data('oldValue', $(this).val());
		});
		// cabin class on change
		$('.cabin-class').on('change', function() {
			if($('.ibe_freesidetrip').is(":visible")) 
					{
					$('.ibe_freesidetrip').hide();					
					$('.single-city--bookflight').show();
					}		
		});
		// on value increment/decrement, update old value data-attribute
		_self.$instance.find('#mob-enrich-redeem-points--container .minus-plus-input').on('change', function() {
			// adultInfantValidation();

			let minValue     = parseInt($(this).attr('min'));
			let maxValue     = parseInt($(this).attr('max'));
			let valueCurrent = parseInt($(this).val());
			let name         = $(this).attr('name');

			if (valueCurrent >= minValue) {
				curInstance.find(".mobile-ticketnos--btn[data-type='minus'][data-field='"+name+"']").removeAttr('disabled');
			} else {
				$(this).data('oldValue',$(this).val());
			}

			if (valueCurrent <= maxValue) {
				curInstance.find(".mobile-ticketnos--btn[data-type='plus'][data-field='"+name+"']").removeAttr('disabled');
			} else {
				$(this).data('oldValue',$(this).val());
			}
			updateTicketQtys();
		});

		// prevent input to passenger number field by keyboard
		// only allow change from pressing buttons
		_self.$instance.find('#mob-enrich-redeem-points--container .minus-plus-input').on('keydown', function (e:any) {
			if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
				(e.keyCode == 65 && e.ctrlKey === true) ||
				(e.keyCode >= 35 && e.keyCode <= 39)) {
				return;
			}
			if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
				e.preventDefault();
			}
		});

		// run once on ready
		// _self.$instance.find('.minus-plus-input').trigger('change');
		// updateTicketQtys();

		/**
		 * calculate total ticket amount based on current values and populate display fields
		 * @return void
		 */
		function updateTicketQtys() {
			let $passengerDetailsActive = curInstance.find('[mob-data-booking-passenger-details-selected]');

			// get current values in input field and assign to method vars
			$ticketRoomInput = parseInt($passengerDetailsActive.find('.ticket-mob-room--input').val());
			$ticketAdultInput = parseInt($passengerDetailsActive.find('.ticket-mob-adult--input').val());
			$ticketChildInput = parseInt($passengerDetailsActive.find('.ticket-mob-child--input').val());


			// only adult and child tickets count towards limit 
			$totalTickets = $ticketAdultInput + $ticketChildInput;
			$totalRooms =$ticketRoomInput;
			let $totalPassengersVal: any = $totalTickets 
			let $totalRoomsVal: any = $totalRooms 
			let $totalPassenger: any = curInstance.find('.total-passengers');
		

			// update hidden input value for total tickets added
			// update display text for total tickets added
			_self.$instance.find('#mob-enrich-redeem-points--container .total-tickets--value').val($totalTickets);
			$totalPassenger.find('.total-nos').html($totalPassengersVal);
			$totalPassenger.find('.total-nos-rooms').html($totalRoomsVal);
			let $totalTravelerDisplay: any = curInstance.find('.total-passengers');
			if ($totalTickets >= 2) {
				//$totalPassengerDisplay.find('.type').html('Passengers');
				$totalTravelerDisplay.find('.type').html('Guests');
			} else {
				//$totalPassengerDisplay.find('.type').html('Passenger');
				$totalTravelerDisplay.find('.type').html('Guest');
			}

			if ($totalRooms >= 2) {
				//$totalPassengerDisplay.find('.type').html('Passengers');
				$totalTravelerDisplay.find('.typeRoom').html('Rooms');
			} else {
				//$totalPassengerDisplay.find('.type').html('Passenger');
				$totalTravelerDisplay.find('.typeRoom').html('Room');
			}


			if ($totalTickets >= 5) {
				curInstance.find('.room-nos .input-group--btn .plus').attr('disabled', true);
				curInstance.find('.adult-nos .input-group--btn .plus').attr('disabled', true);
				curInstance.find('.child-nos .input-group--btn .plus').attr('disabled', true);
			} else {
				curInstance.find('.room-nos .input-group--btn .plus').attr('disabled', false);
				curInstance.find('.adult-nos .input-group--btn .plus').attr('disabled', false);
				curInstance.find('.child-nos .input-group--btn .plus').attr('disabled', false);
			}
			if($ticketRoomInput>=3){
				curInstance.find('.room-nos .input-group--btn .plus').attr('disabled', true);
			}
		

		}

	}

}

let scope: Element = document.querySelector('[data-mob-enrich--enrich-hotels]');
if (scope) {

	try {
		let mobenrichhotels = new mobileBookingFormContent();
		let bookingformcommon = new bookingFormCommon();
		let bookflightredemption = new bookingFormRedemption();
		let bookflightinfant = new bookingFormInfant();
		let bookingformsideTrip = new bookingFormSideTrip();
		// start: init navbar behavior
		mobenrichhotels.nav();
		mobenrichhotels.init();
		mobenrichhotels.setInstance('#mobile-enrichhotels--container');
		mobenrichhotels.initCalendar();
		mobenrichhotels.populateTuiMobEnrichEarnLocationList($('#mob-enrich-earn-points--container'));
		mobenrichhotels.populateTuiMobEnrichRedeemLocationList($('#mob-enrich-redeem-points--container'));
		// mobenrichhotels.mobPassengerDetailsEnrichHotelEarn();
		// mobenrichhotels.mobPassengerDetailsEnrichHotelRedeem();
		mobenrichhotels.passengerTypeMob();
		mobenrichhotels.mobEarnRoomPassengerDetails('#enrich-earn-points--container');
		mobenrichhotels.mobRedeemRoomPassengerDetails('#enrich-redeem-points--container');
		mobenrichhotels.mobEnrichFormSubmitHandler();
		// end: init navbar behavior

	} catch (e) { console.error(e); }
}
